import { SET_MODELS } from './actionTypes';
import { RESET_APP_STATE } from 'store/actionTypes';
import initialState from 'store/initialState';

export default function(state = initialState.models, action) {
  switch (action.type) {
    case SET_MODELS:
      return action.payload;
    case RESET_APP_STATE:
      return initialState.models;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/models/reducer.js